<section *ngIf="input_hasForm" class="tw-w-full">
  <!--file uploader-->
  <div
    *ngIf="!file"
    class="border-3 border-radius tw-min-h-[260px] tw-pb-4 tw-flex-center tw-border-dotted tw-border-gray-700"
    (dragover)="onDragOver($event)"
    (drop)="onDropSuccess($event)"
    (click)="fileInput.click()"
  >
    <div class="m-0 uploader">
      <input
        matInput
        type="text"
        readonly
        [value]="file?.name || ''"
        [formControl]="input_formControlName"
        class="input-file tw-relative tw-bg-transparent"
      />
      <input
        type="file"
        multiple
        hidden
        #fileInput
        [value]="file"
        [accept]="input_fileAccept"
        [placeholder]="input_placeholder | translate"
        (input)="onCheckFile($event)"
      />
      <div ngxMatFileInputIcon class="m-0 tw-static uploader">
        <div class="tw-w-full tw-flex tw-justify-center">
          <i
            class="mdi mdi-cloud-upload-outline mdi-70px text-navyBlue"
            after-label
          ></i>
        </div>
        <div class="tw-w-full tw-flex tw-justify-center">
          <div
            class="tw-m-[10px] tw-text-gray-850 dark:tw-text-gray-200 tw-font-medium"
          >
            {{ "messages.dragFile" | translate }}
          </div>
        </div>
        <div class="tw-w-full tw-flex tw-justify-center tw-mt-5">
          <div class="tw-text-gray-850 dark:tw-text-gray-200 tw-font-medium">
            {{ "messages.validMediaTypes" | translate }}
          </div>
        </div>
        <div class="tw-flex-wrap tw-flex tw-justify-center tw-mt-3">
          <span
            *ngFor="let item of allowedFiles"
            class="dir-ltr tw-bg-primary-100 dark:tw-bg-primary-800 dark:tw-text-primary-100 tw-flex tw-items-center tw-justify-center tw-mx-1 tw-rounded-2xl tw-text-primary-800 tw-h-8 tw-min-w-[33px] tw-px-3 tw-my-1"
            >{{ item }}</span
          >
        </div>
      </div>
      <!-- <ngx-mat-file-input
        #fileInput
        class="input-file"
        [value]="file"
        [accept]="input_fileAccept"
        [formControlName]="input_formControlName"
        (input)="onCheckFile($event)"
        [placeholder]="input_placeholder | translate"
      >
        <div ngxMatFileInputIcon class="m-0 tw-absolute top-50 uploader">
          <div>
            <i
              class="mdi mdi-cloud-upload-outline mdi-70px text-navyBlue"
              after-label
            ></i>
            <div class="tw-m-[10px]">{{ "messages.dragFile" | translate }}</div>
            <div>{{ "messages.validMediaTypes" | translate }}</div>
            <div class="tw-flex-wrap tw-flex">
              <span
                *ngFor="let item of allowedFiles"
                class="dir-ltr tw-bg-primary-100 tw-flex tw-items-center tw-justify-center tw-mx-1 tw-rounded-2xl tw-text-primary-800 tw-h-8 tw-min-w-[33px] tw-px-3 tw-my-1"
                >{{ item }}</span
              >
            </div>
          </div>
        </div>
      </ngx-mat-file-input> -->
    </div>
  </div>

  <!--preview image container-->
  <div
    *ngIf="file"
    class="border-3 border-radius tw-min-h-[260px] tw-pb-4 tw-flex-center tw-border-dotted tw-border-gray-700 tw-p-[10px]"
  >
    <div class="img-container tw-group tw-relative tw-flex">
      <div
        class="tw-absolute tw-hidden group-hover:tw-flex tw-w-full tw-h-full tw-bg-slate-50 dark:tw-bg-slate-800 tw-opacity-40 tw-z-[1] tw-right-0 tw-justify-center tw-items-center"
      ></div>

      <!-- delete button -->
      <div class="tw-absolute tw-cursor-pointer tw-hidden group-hover:tw-block">
        <a (click)="clearFile()" class="tw-flex-center text-danger">
          <i
            class="mdi mdi-trash-can-outline mdi-30px tw-ml-[10px] ltr:tw-mr-[10px] text-danger tw-z-10"
          ></i>
        </a>
      </div>

      <!--image preview-->
      <img *ngIf="imageUrl" [src]="imageUrl" alt="Photo" class="img-preview" />
      <img *ngIf="fileUrl" [src]="fileUrl" alt="File" class="img-preview" />
    </div>
  </div>
</section>
